import { api } from "@/api/axios.ts";
import {
  ApiJobProfile,
  ApiJobProfileMatrixPayload,
  ApiJobProfileMovePayload,
  ApiJobProfileSavePayload,
  ApiJobProfileSearchPayload,
} from "@/types/job-profile.types.ts";
import { ApiPagedData } from "@skailer-com/uikit/core";

export const apiJobProfiles = {
  getAll: async function (includeArchived: boolean = false) {
    return api.get<ApiJobProfile[]>("/api/v1/job-profiles", { include_archived: includeArchived });
  },
  search: async function (payload: ApiJobProfileSearchPayload) {
    return api.post<ApiPagedData<ApiJobProfile>>("/api/v1/job-profiles/search", payload);
  },
  getById: async function (id: number) {
    return api.get<ApiJobProfile>(`/api/v1/job-profiles/${id}`);
  },
  update: async function (id: number, payload: ApiJobProfileSavePayload) {
    return api.put<ApiJobProfile>(`/api/v1/job-profiles/${id}`, payload);
  },
  matrix: async function (payload: ApiJobProfileMatrixPayload) {
    return api.put<ApiJobProfile[]>("/api/v1/job-profiles/matrix", payload);
  },
  move: async function (id: number, payload: ApiJobProfileMovePayload) {
    return api.put<ApiJobProfile>(`/api/v1/job-profiles/${id}/move`, payload);
  },
  delete: async function (id: number) {
    return api.delete(`/api/v1/job-profiles/${id}`);
  },
};
